module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.eb43b4c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/font/roboto/Roboto-Bold.woff
// module id = EzVi
// module chunks = 0